<template>
  <div class="coolant-sample-detail" v-if="!isLoading">
    <header>
      <h3>Coolant Sample: {{ sampleData.coolantSample.sampleNumber }}</h3>
      <div class="action-bar print-remove">
        <button
          class="k-button k-primary"
          title="View Report"
          @click="openButtonLink(endpoints.reportRoute)"
        >
          View Report
        </button>
        <button
          class="k-button k-primary"
          title="Graph Data"
          @click="openButtonLink(endpoints.graphRoute)"
        >
          Graph Data
        </button>
        <button
          class="k-button k-primary"
          title="Graph History"
          @click="openButtonLink(endpoints.graphRoute, true)"
        >
          Graph History
        </button>
      </div>
    </header>
    <div class="sample-data">
      <ContextualInfo :sampleData="sampleData" />
      <SampleInfo :coolantSample="sampleData.coolantSample" />
    </div>
  </div>
</template>

<script>
import GridDataService from 'services/grid-data.service';
import Constants from '../../../constants/constants';
import ContextualInfo from './CoolantSampleDetailContextualInfo.vue';
import SampleInfo from './CoolantSampleDetailSampleInfo.vue';

export default {
  components: {
    ContextualInfo,
    SampleInfo
  },
  data() {
    return {
      sampleData: {},
      isLoading: true,
      endpoints: Constants.Api.Endpoint.CoolantSample
    };
  },
  mounted() {
    const queryString = new URLSearchParams(window.location.search);
    const id = parseInt(queryString.get('id'), 10);

    if (!id) {
      window.alert('The ID given does not exist or none was provided. Please try again.');

      return;
    }

    GridDataService.getSampleById({
      apiUrl: Constants.Api.Endpoint.CoolantSample.detailPortalApi,
      params: {
        id
      }
    }).then(({ data }) => {
      this.sampleData = data;
      this.isLoading = false;
    });
  },
  methods: {
    openButtonLink(url, addViewUnit) {
      window.open(url + window.location.search + (addViewUnit ? '&viewunit' : ''), '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.coolant-sample-detail {
  padding: 20px;

  .sample-data {
    @include fontSize(14px);
  }

  header {
    align-items: center;
    display: flex;
    flex-direction: row nowrap;
    justify-content: space-between;

    h3 {
      margin-left: 23px;
      color: $accent;
    }
  }

  .sample-data {
    border-top: dotted 2px #000;
    margin-top: 10px;
    padding-top: 10px;
  }
}
</style>
